<template>
    <div class="page" id="history" v-if="player">
        <header class="pageHeader rounded">
            <fade-image class="darken" src="assets/headers/players.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Lesson History</h2>
                <ul class="links">
                    <li v-if="$env.VUE_APP_VIDEO_LESSON_ENABLED">
                        <a
                            @click.prevent="toggleShowVideos"
                            :class="{ active: showType == 1 }"
                            class="video"
                            href="#"
                        >
                            <img src="@/assets/videolesson/video-icon.svg" v-show="!showType" />
                            <img
                                src="@/assets/videolesson/video-icon-active.svg"
                                v-show="showType"
                            />
                        </a>
                    </li>
                    <li>
                        <a @click.prevent="favourites = !favourites" class="star" href="#">
                            <img v-if="!favourites" src="@/assets/icons/star-unfilled.svg" />
                            <img v-else src="@/assets/icons/star-fill.svg" />
                        </a>
                    </li>
                    <li></li>
                    <li>
                        <router-link
                            class="cancel"
                            :to="{
                                name: 'proPlayer',
                                params: { id: $route.params.id },
                            }"
                            ><x-icon class="icon"
                        /></router-link>
                    </li>
                </ul>
            </header>

            <span class="player">{{ player.first_name }} {{ player.last_name }}</span>

            <ul class="lessonList">
                <li
                    class="historyLesson"
                    v-for="lesson in lessonsReversed"
                    :key="lesson.id"
                    :class="{
                        noRecord: showCreateLesson(lesson),
                        'type-0': lesson.type == 0,
                        'type-1': lesson.type == 1,
                    }"
                >
                    <router-link
                        :to="{
                            name: 'proPlayerLesson',
                            params: { id: lesson.player.id, lesson: lesson.id },
                        }"
                    >
                        <img
                            class="record-type-video-icon"
                            v-show="lesson.type == 1 && !showCreateLesson(lesson)"
                            src="@/assets/videolesson/video-record-icon.svg"
                        />
                        <span v-if="showCreateLesson(lesson)">
                            {{ $date(lesson.date).format("DD MMM YYYY") }}
                            <strong>Create new lesson record</strong>
                            <img class="recordArrow" src="@/assets/arrow-plus-white.svg" />
                        </span>
                        <span v-else>
                            <b>
                                <span v-if="!lesson.title" class="title"> Untitled record </span>
                                <span class="title" v-else>
                                    {{ lesson.title }}
                                </span>
                            </b>
                            {{ $date(lesson.date).format("DD MMM YYYY") }}

                            <template v-if="lesson.start != lesson.end">
                                {{ $date("2020-12-08 " + lesson.start).format("HH:mm") }}
                                -
                                {{ $date("2020-12-08 " + lesson.end).format("HH:mm") }}
                            </template>

                            <lesson-star :lesson="lesson" />
                            <img class="recordArrow" src="@/assets/arrow-right-white.svg" />
                        </span>
                    </router-link>
                </li>
            </ul>

            <!--<router-link class="button dark " :to="{name:'proLessonBook', query:{id:player.id,from:'history'}}">
                  Add new lesson
                  <plus-icon class="icon"></plus-icon>
                </router-link>-->
        </div>
    </div>
</template>

<script>
import LessonStar from "@/components/Player/Lessons/lesson-star";
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";

export default {
    name: "history",
    components: {
        XIcon,
        LessonStar,
        FadeImage,
    },
    created() {
        this.$store.dispatch("getPlayer", this.$route.params.id);
    },
    data() {
        return {
            favourites: false,
            showType: null,
        };
    },
    computed: {
        player() {
            return this.$store.state.activePlayer;
        },
        lessonsReversed() {
            let lessons = this.player.lessons;

            if (this.favourites) {
                lessons = lessons.filter((lesson) => {
                    return lesson.pro_starred == true;
                });
            }

            if (this.showType) {
                lessons = lessons.filter((lesson) => {
                    return lesson.type == this.showType;
                });
            }

            return lessons.slice().reverse();
        },
    },
    methods: {
        toggleShowVideos() {
            if (!this.showType) {
                this.showType = 1;
            } else {
                this.showType = null;
            }
        },
        showCreateLesson(lesson) {
            if (!lesson.record) {
                return true;
            }
            let nonPlayerRecords = lesson.record.filter((record) => !record.is_player_submitted);
            return nonPlayerRecords.length == 0;
        },
    },
};
</script>

<style lang="scss" scoped>
#history {
    .record-type-video-icon {
        position: absolute;
        top: -4px;
        right: 15px;
    }
    .player {
        display: block;
        border-radius: $radius;
        padding: 20px;
        padding-top: 17px;
        padding-bottom: 17px;
        background: darken($grey, 05);
        margin-bottom: 10px;
        height: 52px;
        color: $green_0;
    }
    .lessonList {
        margin-bottom: 30px;
    }
    .star {
        position: absolute;
        right: 35px;
        top: -10px;
        padding: 13px;
    }
    .links {
        .video {
            position: absolute;
            right: 70px;
            top: -8px;
            padding: 13px;
        }
    }
    .historyLesson {
        background: white;
        border-radius: $radius;
        margin-bottom: 10px;
        padding: 17px 20px;
        position: relative;

        &.type-1 {
            background-color: #fbf9f4 !important;

            &.noRecord {
                background-color: #444745 !important;
            }
        }

        a {
            text-decoration: none;
            color: $green_0;
            font-weight: 200;
        }
        &.noRecord {
            background: $green_0;
            color: white;
            a {
                color: white;
                font-weight: 200;
            }
            strong {
                font-weight: 400;
                display: block;
                margin-top: 10px;
            }
        }
        b {
            font-weight: 400;
            margin-bottom: 10px;
            display: block;
        }
        .recordArrow {
            position: absolute;
            right: 15px;
            bottom: 20px;
            pointer-events: none;
        }
        .star {
            position: absolute;
            right: 24px;
            bottom: 3px;
            top: auto;
        }
    }
    .title {
        line-height: 1.5;
    }
}
</style>
